import BeneficialOwnersInput from "./BeneficialOwnersInput"

export default BeneficialOwnersInput
